export default function About() {
  return (
    <div className="bg-slate-900 min-h-screen text-white pb-20">
      <div className="max-w-4xl mx-auto px-4 pt-20">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-8 bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent">
          Our Mission: Maximum Value, Minimum Effort.
        </h1>
        
        <div className="space-y-12 text-slate-300 text-lg leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">The Problem</h2>
            <p>
              Credit card rewards in India have become a maze of complex T&Cs, hidden devaluations, 
              and confusing milestone benefits. Most users end up using the wrong card for the wrong 
              category, leaving thousands of rupees in value on the table every single month.
            </p>
          </section>

          <section className="bg-slate-800/50 p-8 rounded-3xl border border-slate-700">
            <h2 className="text-2xl font-bold text-white mb-4">The SiftCard Solution</h2>
            <p>
              We built SiftCard to level the playing field. Our AI-driven engine analyzes your 
              unique spending patterns against the live reward structures of 100+ Indian credit 
              cards. We don't just give you a list; we give you a <strong>Roadmap</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">The Team Behind the AI</h2>
            <p>
              SiftCard is a product of <strong>Seedmind Technologies</strong>, based in Hyderabad. 
              The project was born out of a passion for data-driven decision making. With a 
              foundational background in Business Analytics, we ensured that SiftCard's 
              recommendations aren't just "guesses"—they are mathematically optimized for your wallet.
            </p>
          </section>

          <section className="border-t border-slate-800 pt-10">
            <h2 className="text-2xl font-bold text-white mb-4 italic">"We never ask for your card numbers. We only care about your rewards."</h2>
          </section>
        </div>
      </div>
    </div>
  );
}
